export default __webpack_public_path__ + "static/media/Template5.b029bab6.png";